<!---->
<template>
  <el-form-item
    ref="formItemRef"
    v-bind="$attrs"
    :prop="prop"
    :rules="rules"
    :show-message="isShowMessage"
    :required="required"
    :class="$slots.labelOuterSide ? 'rt-form-labelouter-slot' : ''"
    class="rt-form-item-wrapper"
  >
    <span
      v-if="!hiddenLabel"
      v-show="label"
      slot="label"
      :class="[tooltip ? 'rt-form-item-wrapper-tooltip' : '']"
      class="rt-form-item-label-wrapper"
    >
      <!-- 辅助信息（label前的图标和label后的tooltip） -->
      <div class="rt-form-item-label-auxiliary">
        <div class="rt-form-item-label-icon-tooltip">
          <!-- 自定义label图标 -->
          <rt-icon
            v-if="labelIcon"
            :name="labelIcon"
            :color="labelIconColor"
            :size="labelIconSize"
            :style="{ 'margin-right': labelIconRight }"
          ></rt-icon>
          <!-- 自定义帮助信息(Tooltip) -->
          <rt-tooltip
            v-if="tooltip && labelPosition === 'left'"
            :content="tooltip"
            effect="dark"
            placement="top"
          >
            <rt-icon
              :color="SCSS_VARIABLES.NEUTRAL_COLOR_REGULAR"
              :name="tooltipIconName"
              size="12"
            />
          </rt-tooltip>
          <rt-tooltip
            :content="String(label)"
            :disabled="!isShowTooltip"
            placement="bottom"
          >
            <span
              ref="labelText"
              class="label"
            >{{ label }}</span>
          </rt-tooltip>
          <rt-tooltip
            v-if="tooltip && labelPosition !== 'left'"
            :content="tooltip"
            effect="dark"
            placement="top"
          >
            <rt-icon
              :color="SCSS_VARIABLES.NEUTRAL_COLOR_REGULAR"
              :name="tooltipIconName"
              size="12"
            />
          </rt-tooltip>
        </div>
        <!-- 辅助信息（label后的描述信息） -->
        <div class="rt-form-item-label-description">
          <span>{{ labelDescription }}</span>
        </div>
      </div>

      <rt-icon
        v-if="(isRequired || this.$attrs.required) && !disabled"
        class="rt-icon-required"
        name="rt-base-required-lined"
        size="10"
      />
    </span>
    <!-- 【表单】支持设置label右侧插槽 -->
    <span
      v-if="!disabled && $slots.labelRightSide"
      slot="label-right"
      class="is-label-slot"
    >
      <slot name="labelRightSide"></slot>
    </span>
    <slot />
    <!-- 【表单】支持设置label外侧插槽 -->
    <span
      v-if="!disabled && $slots.labelOuterSide"
      :class="{ 'is-label-outer ': labelContorl }"
    >
      <slot name="labelOuterSide"></slot>
    </span>
  </el-form-item>
</template>

<script>
import config from '../../config';
import RtIcon from '../icon/rtIcon.vue';
import { getPropByPath } from '../../utils/util.js';
import ElFormItem from 'vue-xpc/src/element-ui/packages/form/src/form-item';
const methods = ['resetField', 'clearValidate'];
function is_all_ws (node) {
  return !/[^\t\n\r ]/.test(node.data);
}

function is_ignorable (node) {
  return (
    Number(node.nodeType) === 8 || // 注释节点
    (Number(node.nodeType) === 3 && is_all_ws(node))
  ); // 仅含空白符的文字节点
}
function node_after (sib) {
  while (sib && (sib = sib.nextSibling)) {
    if (!is_ignorable(sib)) return sib;
  }
  return null;
}

export default {
  name: 'RtFormItem',
  components: { RtIcon, ElFormItem },
  props: {
    // 控制label外侧插槽边框样式
    labelContorl: {
      type: Boolean,
      default: true
    },
    label: String,
    prop: String,
    tooltip: String,
    tooltipIconName: {
      type: String,
      default: 'rt-base-circle-question-lined'
    },
    rules: [Object, Array],
    // 来自全局config.js，控制elemment-ui的show-message属性，是否显示校验错误信息
    isShowMessage: {
      type: Boolean,
      default: config.get('formItemIsShowMessage') !== false
    },
    // label图标
    labelIcon: {
      type: String,
      default: null
    },
    // label图标颜色，支持所有主题色和n-secondary\n-regular\n-primary
    labelIconColor: {
      type: String,
      default: function () {
        return this.SCSS_VARIABLES.COLOR_INFO;
      }
    },
    // label图标大小
    labelIconSize: {
      type: Number,
      default: 16
    },
    // label图标右间距
    labelIconRight: {
      type: Number,
      default: 4
    },
    // label右侧描述信息
    labelDescription: String,
    required: {
      type: Boolean,
      default: undefined
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    }
  },
  inject: {
    elForm: {
      default: ''
    },
    labelPosition: {
      default: 'top'
    }
  },
  provide () {
    return { rtFormItem: this }
  },
  data () {
    return {
      disabled: false,
      // 包含 disabled 属性的元素
      containerDisabled: null,
      // label是否显示tooltip
      isShowTooltip: false
    };
  },
  computed: {
    isRequired () {
      let rules = this.getRules();
      let isRequired = false;

      if (rules && rules.length) {
        isRequired = rules.some(rule => rule.required);
      }
      return isRequired;
    },
    changeDisabled () {
      if (this.containerDisabled) {
        let simpleDisabled =
          this.containerDisabled && this.containerDisabled.disabled;
        let complexDisabled =
          this.containerDisabled &&
          this.containerDisabled.$children &&
          this.containerDisabled.$children[0]
            ? this.containerDisabled.$children[0].disabled
            : false;
        let formDisabled = (this.elForm || {}).disabled;
        return {
          simpleDisabled,
          complexDisabled,
          formDisabled
        };
      }
      return {};
    }
  },
  watch: {
    // 监听 disabled 属性是否发生变化
    changeDisabled: {
      handler (newValue) {
        if (!Object.values(newValue).some(item => !!item)) {
          this.disabled = false;
          this.$el.classList.remove('is-disabled');
        } else {
          this.disabled = true;
          this.$el.classList.add('is-disabled');
        }
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this._isDestroyed) {
        return;
      }

      // 如果子节点中有 disabled 属性，在 label 后追加图标
      const contentElement = this.$children[0].$children[1];

      this.containerDisabled = contentElement;

      if (!contentElement) {
        return;
      }

      let isDisabled;

      if (this.$el.querySelector('.rt-daterangepicker')) {
        isDisabled = contentElement.$children[0].disabled;
      } else {
        isDisabled =
          (this.elForm || {}).disabled ||
          contentElement.disabled ||
          contentElement.$children.some(item => item.disabled);
      }

      if (isDisabled) {
        this.disabled = true;
        this.$el.classList.add('is-disabled');
      }

      // 将 elementui formItem 组件原生方法附加在 rtFromItem 上面
      methods.forEach(method => {
        this[method] = this.$refs.formItemRef && this.$refs.formItemRef[method];
      });

      // 在 input 后面追加一个 div，用来实现输入框阴影效果
      let $input =
        this.$el.querySelector('input.el-input__inner') ||
        this.$el.querySelector('textarea.el-textarea__inner') ||
        this.$el.querySelector('input.el-range-input');
      let refrenceNode = node_after($input);

      if ($input && $input.parentElement) {
        // 获取父节点
        let $parent = $input.parentElement;
        // 构建 box-shadow 节点
        let shadowNode = document.createElement('div');
        shadowNode.classList.add('rt-input-shadow');
        $parent.insertBefore(shadowNode, refrenceNode);
      }

      if (this.$refs.labelText) {
        this.isShowTooltip = this.$refs.labelText.offsetWidth < this.$refs.labelText.scrollWidth;
      }
    });
  },

  destroyed () {
    this._isDestroyed = true;
  },
  methods: {
    getRules () {
      let formRules = this.elForm.rules;
      const required = !!this.required;
      const selfRules = this.rules;
      const requiredRule = required ? { required } : [];

      const prop = getPropByPath(formRules, this.prop || '');
      formRules = formRules ? prop.o[this.prop || ''] || prop.v : [];

      return [].concat(selfRules || formRules || []).concat(requiredRule);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtFormItem.vue?ab0c654a